export const DOWNPAYMENT_LABEL = 'Down payment';
